/**
 * Status als Marke.
 *
 * Die Farbe ist Zugabe, das Wort ist die Aussage — sonst wäre der Status
 * für jemanden mit Rotgrünschwäche geraten. Aus demselben Grund wird
 * „storniert" zusätzlich durchgestrichen.
 */
import type { ReactNode } from 'react';
import { statusWort } from '../lib/format';
import type { Ton } from './Meldung';

const TON: Record<string, Ton | 'neutral'> = {
  entwurf: 'neutral',
  erfasst: 'info',
  gebucht: 'gut',
  festgeschrieben: 'gut',
  storniert: 'gefahr',
  gestellt: 'info',
  teilbezahlt: 'warnung',
  bezahlt: 'gut',
  ueberfaellig: 'gefahr',
  versendet: 'info',
  angenommen: 'gut',
  abgelehnt: 'gefahr',
  abgelaufen: 'neutral',
  offen: 'warnung',
  zugeordnet: 'gut',
  teilzugeordnet: 'warnung',
  privat: 'neutral',
  unerheblich: 'neutral',
  ignoriert: 'neutral',
  angefragt: 'warnung',
  gueltig: 'gut',
  widerrufen: 'neutral',
};

export function Marker({ status }: { status: string | null | undefined }): ReactNode {
  if (!status) return <span className="still">—</span>;
  const ton = TON[status] ?? 'neutral';
  const klassen = ['marker'];
  if (ton !== 'neutral') klassen.push(ton);
  if (status === 'storniert') klassen.push('durchgestrichen');
  return <span className={klassen.join(' ')}>{statusWort(status)}</span>;
}
